import { Service } from '@hud/portal-dtos/webapp-service.dto';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import Menu, { MenuButton } from '@hud/web-components/Menu/Menu';
import React from 'react';

export interface ServiceMenuProps {
  services: Service[];
  selectedServiceId: number | null;
  onServiceSelect: (serviceId: number) => void;
}

export default function ServiceMenu({
  services,
  selectedServiceId,
  onServiceSelect,
}: ServiceMenuProps) {
  return (
    <Menu.Menu>
      <Menu.Target>
        <div>
          <MenuButton>
            {selectedServiceId
              ? services.find((service) => service.id === selectedServiceId)
                  ?.name
              : 'Select Service'}
            <HudIcon icon="menu.caretDown" size="14px" />
          </MenuButton>
        </div>
      </Menu.Target>
      <Menu.Dropdown>
        {services.map((service) => (
          <Menu.Item
            key={service.id}
            onClick={() => onServiceSelect(service.id)}
          >
            {service.name}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu.Menu>
  );
}
